<template>
  <section id="servicios" class="section-padding bg-gray-50">
    <div class="container-custom">
      <!-- Title -->
      <div class="text-center mb-16 animate-fade-in-up">
        <h2 class="section-title">{{ $t('services.title') }}</h2>
      </div>

      <!-- Services Grid -->
      <div class="space-y-16">
        <!-- Service 1: Express (Image Right) -->
        <div
          class="card grid md:grid-cols-2 gap-8 items-center overflow-hidden animate-fade-in-up"
        >
          <div class="p-8 md:p-12 order-2 md:order-1">
            <div class="flex items-center gap-3 mb-4">
              <div class="w-12 h-12 rounded-full gradient-corporate flex items-center justify-center">
                <font-awesome-icon icon="bolt" class="text-white text-xl" />
              </div>
              <h3 class="text-2xl md:text-3xl font-bold text-navy-500">
                {{ $t('services.express.title') }}
              </h3>
            </div>
            <p class="text-gray-600 leading-relaxed mb-6">
              {{ $t('services.express.description') }}
            </p>
            <a
              href="https://client.motoboychile.app/sign-up"
              target="_blank"
              rel="noopener noreferrer"
              class="btn-primary inline-flex items-center gap-2"
            >
              <span>{{ $t('services.express.cta') }}</span>
              <font-awesome-icon icon="arrow-right" />
            </a>
          </div>
          <div class="relative h-64 md:h-full order-1 md:order-2">
            <img
              src="/images/service-express.jpg"
              alt="Servicio Express"
              class="w-full h-full object-cover"
              onerror="this.style.background='linear-gradient(135deg, #f59e0b 0%, #f97316 100%)'"
            />
          </div>
        </div>

        <!-- Service 2: Junior (Image Left) -->
        <div
          class="card grid md:grid-cols-2 gap-8 items-center overflow-hidden animate-fade-in-up delay-100"
        >
          <div class="relative h-64 md:h-full order-1">
            <img
              src="/images/service-junior.jpg"
              alt="Junior Corporativo"
              class="w-full h-full object-cover"
              onerror="this.style.background='linear-gradient(135deg, #eab308 0%, #f59e0b 100%)'"
            />
          </div>
          <div class="p-8 md:p-12 order-2">
            <div class="flex items-center gap-3 mb-4">
              <div class="w-12 h-12 rounded-full gradient-corporate flex items-center justify-center">
                <font-awesome-icon icon="motorcycle" class="text-white text-xl" />
              </div>
              <h3 class="text-2xl md:text-3xl font-bold text-navy-500">
                {{ $t('services.junior.title') }}
              </h3>
            </div>
            <p class="text-gray-600 leading-relaxed mb-6">
              {{ $t('services.junior.description') }}
            </p>
            <a
              href="https://client.motoboychile.app/sign-up"
              target="_blank"
              rel="noopener noreferrer"
              class="btn-primary inline-flex items-center gap-2"
            >
              <span>{{ $t('services.junior.cta') }}</span>
              <font-awesome-icon icon="arrow-right" />
            </a>
          </div>
        </div>

        <!-- Service 3: Delivery (Image Right) -->
        <div
          class="card grid md:grid-cols-2 gap-8 items-center overflow-hidden animate-fade-in-up delay-200"
        >
          <div class="p-8 md:p-12 order-2 md:order-1">
            <div class="flex items-center gap-3 mb-4">
              <div class="w-12 h-12 rounded-full gradient-corporate flex items-center justify-center">
                <font-awesome-icon icon="truck" class="text-white text-xl" />
              </div>
              <h3 class="text-2xl md:text-3xl font-bold text-navy-500">
                {{ $t('services.delivery.title') }}
              </h3>
            </div>
            <p class="text-gray-600 leading-relaxed mb-6">
              {{ $t('services.delivery.description') }}
            </p>
            <a
              href="https://client.motoboychile.app/sign-up"
              target="_blank"
              rel="noopener noreferrer"
              class="btn-primary inline-flex items-center gap-2"
            >
              <span>{{ $t('services.delivery.cta') }}</span>
              <font-awesome-icon icon="arrow-right" />
            </a>
          </div>
          <div class="relative h-64 md:h-full order-1 md:order-2">
            <img
              src="/images/service-delivery.jpg"
              alt="Delivery Programado"
              class="w-full h-full object-cover"
              onerror="this.style.background='linear-gradient(135deg, #f97316 0%, #ea580c 100%)'"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
// No se necesita lógica adicional por ahora
</script>
